import React, { FunctionComponent } from 'react'
import { RateItem } from './RateItem'
import styles from './style.module.scss'
import { RateSizes } from './constants'

export interface RateProps {
  value: number
  size?: RateSizes
}

export const Rate: FunctionComponent<RateProps> = ({ value, size = 'Medium' }): JSX.Element => {
  return (
    <ul className={styles.container}>
      {Array(5)
        .fill(0)
        .map((_, idx) => (
          <RateItem key={idx} index={idx + 1} value={value} size={size} />
        ))}
    </ul>
  )
}
